import * as y from "react";
import { j as x } from "./jsx-runtime-3tyXYecC.mjs";
import { g as I, c as C } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as R } from "./memoTheme-BzXKG_-k.mjs";
import { g as w } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { s as b, u as j, c as M } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { c as z } from "./tss-DN0acMKN.mjs";
function N(o) {
  return I("MuiSvgIcon", o);
}
w("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const $ = (o) => {
  const {
    color: e,
    fontSize: r,
    classes: s
  } = o, t = {
    root: ["root", e !== "inherit" && `color${z(e)}`, `fontSize${z(r)}`]
  };
  return M(t, N, s);
}, A = b("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (o, e) => {
    const {
      ownerState: r
    } = o;
    return [e.root, r.color !== "inherit" && e[`color${z(r.color)}`], e[`fontSize${z(r.fontSize)}`]];
  }
})(R(({
  theme: o
}) => {
  var e, r, s, t, l, d, n, u, c, f, a, m, g, p;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    flexShrink: 0,
    transition: (t = (e = o.transitions) == null ? void 0 : e.create) == null ? void 0 : t.call(e, "fill", {
      duration: (s = (r = (o.vars ?? o).transitions) == null ? void 0 : r.duration) == null ? void 0 : s.shorter
    }),
    variants: [
      {
        props: (i) => !i.hasSvgAsChild,
        style: {
          // the <svg> will define the property that has `currentColor`
          // for example heroicons uses fill="none" and stroke="currentColor"
          fill: "currentColor"
        }
      },
      {
        props: {
          fontSize: "inherit"
        },
        style: {
          fontSize: "inherit"
        }
      },
      {
        props: {
          fontSize: "small"
        },
        style: {
          fontSize: ((d = (l = o.typography) == null ? void 0 : l.pxToRem) == null ? void 0 : d.call(l, 20)) || "1.25rem"
        }
      },
      {
        props: {
          fontSize: "medium"
        },
        style: {
          fontSize: ((u = (n = o.typography) == null ? void 0 : n.pxToRem) == null ? void 0 : u.call(n, 24)) || "1.5rem"
        }
      },
      {
        props: {
          fontSize: "large"
        },
        style: {
          fontSize: ((f = (c = o.typography) == null ? void 0 : c.pxToRem) == null ? void 0 : f.call(c, 35)) || "2.1875rem"
        }
      },
      // TODO v5 deprecate color prop, v6 remove for sx
      ...Object.entries((o.vars ?? o).palette).filter(([, i]) => i && i.main).map(([i]) => {
        var S, v;
        return {
          props: {
            color: i
          },
          style: {
            color: (v = (S = (o.vars ?? o).palette) == null ? void 0 : S[i]) == null ? void 0 : v.main
          }
        };
      }),
      {
        props: {
          color: "action"
        },
        style: {
          color: (m = (a = (o.vars ?? o).palette) == null ? void 0 : a.action) == null ? void 0 : m.active
        }
      },
      {
        props: {
          color: "disabled"
        },
        style: {
          color: (p = (g = (o.vars ?? o).palette) == null ? void 0 : g.action) == null ? void 0 : p.disabled
        }
      },
      {
        props: {
          color: "inherit"
        },
        style: {
          color: void 0
        }
      }
    ]
  };
})), h = /* @__PURE__ */ y.forwardRef(function(e, r) {
  const s = j({
    props: e,
    name: "MuiSvgIcon"
  }), {
    children: t,
    className: l,
    color: d = "inherit",
    component: n = "svg",
    fontSize: u = "medium",
    htmlColor: c,
    inheritViewBox: f = !1,
    titleAccess: a,
    viewBox: m = "0 0 24 24",
    ...g
  } = s, p = /* @__PURE__ */ y.isValidElement(t) && t.type === "svg", i = {
    ...s,
    color: d,
    component: n,
    fontSize: u,
    instanceFontSize: e.fontSize,
    inheritViewBox: f,
    viewBox: m,
    hasSvgAsChild: p
  }, S = {};
  f || (S.viewBox = m);
  const v = $(i);
  return /* @__PURE__ */ x.jsxs(A, {
    as: n,
    className: C(v.root, l),
    focusable: "false",
    color: c,
    "aria-hidden": a ? void 0 : !0,
    role: a ? "img" : void 0,
    ref: r,
    ...S,
    ...g,
    ...p && t.props,
    ownerState: i,
    children: [p ? t.props.children : t, a ? /* @__PURE__ */ x.jsx("title", {
      children: a
    }) : null]
  });
});
h && (h.muiName = "SvgIcon");
function V(o, e) {
  function r(s, t) {
    return /* @__PURE__ */ x.jsx(h, {
      "data-testid": `${e}Icon`,
      ref: t,
      ...s,
      children: o
    });
  }
  return r.muiName = h.muiName, /* @__PURE__ */ y.memo(/* @__PURE__ */ y.forwardRef(r));
}
export {
  V as c
};
//# sourceMappingURL=createSvgIcon-ButWPptu.mjs.map
